import React, { useState } from "react";
import { MdAddCircle, MdDeleteForever } from "react-icons/md";
import muscles from "./muscles.json";
import "./styles.css";

type MusclesType = keyof typeof muscles;

const MuscleSerie: React.FC = () => {
  const [factor, setFactor] = useState(0.5);
  const [muscle, setMuscle] = useState<MusclesType | "">("");
  const [part, setPart] = useState<string>("");
  const [muscleList, setMuscleList] = useState<
    { muscle: MusclesType; part: string; factor: number }[]
  >([]);

  const changeConjuct = (e: MusclesType) => {
    setPart("");
    setMuscle(e);
  };

  const addMuscle = () => {
    if (muscle === "" || part === "") return;
    setMuscleList((prev) => [...prev, { muscle, part, factor }]);
    setMuscle("");
    setPart("");
  };

  const removeMuscle = (index: number) => {
    setMuscleList((prev) => prev.filter((_, i) => i !== index));
  };

  const factorBg = (fact: number) =>
    factor === fact ? "bg-zinc-300" : "bg-transparent";

  return (
    <div className="mt-4 flex flex-1 flex-col">
      <div className="h-full w-full overflow-x-auto">
        <div className="border-1 rounded-xl border-zinc-300">
          {" "}
          {/* Outer border wrapper */}
          <table className="w-full min-w-[600px] border-collapse overflow-hidden rounded-xl border border-zinc-200">
            <thead>
              <tr className="bg-zinc-100 text-xs uppercase text-zinc-700">
                <th className="border-b border-zinc-200 px-2 py-3 text-left">
                  Região
                </th>
                <th className="border-b border-zinc-200 px-2 py-3 text-left">
                  Músculo
                </th>
                <th className="w-40 border-b border-zinc-200 px-2 py-3 text-center">
                  Fator
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-zinc-50">
                <td className="p-2 align-middle">
                  <select
                    value={muscle}
                    onChange={(e) =>
                      changeConjuct(e.target.value as MusclesType)
                    }
                    className="h-9 w-full rounded border border-zinc-300 bg-white px-2 text-sm outline-none transition focus:ring-2 focus:ring-primary-400"
                  >
                    <option value={""} disabled>
                      Selecionar Grupo...
                    </option>
                    {Object.keys(muscles).map((e) => (
                      <option key={e} value={e}>
                        {e}
                      </option>
                    ))}
                  </select>
                </td>
                <td className="p-2 align-middle">
                  <select
                    value={part}
                    onChange={(e) => setPart(e.target.value as string)}
                    className="h-9 w-full rounded border border-zinc-300 bg-white px-2 text-sm outline-none transition focus:ring-2 focus:ring-primary-400"
                    disabled={!muscle}
                  >
                    <option value={""} disabled>
                      Selecionar Parte...
                    </option>
                    {muscle &&
                      muscles[muscle].map((e) => <option key={e}>{e}</option>)}
                  </select>
                </td>
                <td className="p-2 text-center align-middle">
                  <div className="flex items-center justify-center gap-2">
                    <button
                      className={`rounded border border-zinc-300 px-3 py-1 text-xs font-semibold transition ${
                        factor === 0.5
                          ? "bg-primary-100 text-primary-700"
                          : "bg-white text-zinc-700 hover:bg-zinc-100"
                      }`}
                      onClick={() => setFactor(0.5)}
                    >
                      0.5
                    </button>
                    <button
                      className={`rounded border border-zinc-300 px-3 py-1 text-xs font-semibold transition ${
                        factor === 1.0
                          ? "bg-primary-100 text-primary-700"
                          : "bg-white text-zinc-700 hover:bg-zinc-100"
                      }`}
                      onClick={() => setFactor(1.0)}
                    >
                      1.0
                    </button>
                    <button
                      className={`ml-2 flex rounded-full border p-1.5 ${
                        muscle === "" || part === ""
                          ? "cursor-not-allowed border-zinc-200"
                          : "border-primary-400 hover:bg-primary-50"
                      }`}
                      onClick={addMuscle}
                      disabled={muscle === "" || part === ""}
                      style={{ alignSelf: "center" }}
                      title="Adicionar"
                    >
                      <MdAddCircle
                        size={22}
                        color={
                          muscle === "" || part === "" ? "#ccc" : "#22c55e"
                        }
                      />
                    </button>
                  </div>
                </td>
              </tr>
              {muscleList.map((e, i) => (
                <tr
                  key={i}
                  className="border-t border-zinc-100 bg-zinc-50 transition-colors hover:bg-zinc-100"
                >
                  <td className="p-2 align-middle">
                    <span className="block text-center text-sm font-medium text-zinc-700">
                      {e.muscle}
                    </span>
                  </td>
                  <td className="p-2 align-middle">
                    <span className="block text-center text-sm font-medium text-zinc-700">
                      {e.part}
                    </span>
                  </td>
                  <td className="flex flex-row items-center justify-between p-2 align-middle">
                    <span className="mx-auto flex text-center text-sm font-semibold text-zinc-700">
                      {e.factor.toFixed(1)}
                    </span>
                    <button
                      onClick={() => removeMuscle(i)}
                      className="rounded-full p-1.5 transition hover:bg-red-50"
                      title="Remover"
                    >
                      <MdDeleteForever size={22} color="#ef4444" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MuscleSerie;
